import axios from "axios";
import { API_URL_EVENTS_LIST_EVENTS, API_URL_EVENTS_SCRAPE_AND_SAVE, API_URL_FOOTBALL_LIST_MATCHES, API_URL_FOOTBALL_SCRAPE_AND_SAVE } from "./Routes";

export interface EventInfo {
    title: string;
    date: string;
    location: string;
    category?: string;
}

export async function getUpcomingEvents() {
    
    try {
        const res = await axios.get(API_URL_EVENTS_LIST_EVENTS, { withCredentials: true });
        return res.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des événements:", error);
        return null;
    }
}

export async function scrapeAndSaveEvents() {
    try {
        const res = await axios.post(API_URL_EVENTS_SCRAPE_AND_SAVE, { withCredentials: true });
        return res.data;
    } catch (error) {
        console.error("Erreur lors du scraping et de la sauvegarde des événements:", error);
        return null;
    }
}

export async function getFootballMatches() {
    try {
        const res = await axios.get(API_URL_FOOTBALL_LIST_MATCHES, { withCredentials: true });
        return res.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des matchs:", error);
        return null;
    }
}

export async function scrapeAndSaveMatches() {
    try {
        const res = await axios.post(API_URL_FOOTBALL_SCRAPE_AND_SAVE, null, { withCredentials: true });
        return res.data;
    } catch (error) {
        console.error("Erreur lors du scraping et de la sauvegarde des matchs:", error);
        return null;
    }
}